module.exports = __webpack_public_path__ + "img/cass9.450766b7.jpg";